import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface BatchToolbarProps {
    selectedCount: number;
    onNewBatch: () => void;
    onPrintBags: () => void;
    onMoveIn: () => void;
    onMoveOut: () => void;
    onCancelBatches: () => void;
    onEndSorting: () => void;
}

/** 发出 tab 工具栏 */
export const BatchToolbar: React.FC<BatchToolbarProps> = ({
    selectedCount, onNewBatch, onPrintBags, onMoveIn, onMoveOut, onCancelBatches, onEndSorting,
}) => {
    const { t } = useTranslation();
    return (
        <div className="flex items-center gap-3 mb-4">
            <Button type="primary" onClick={onNewBatch}>{t('wms.sortingBatch.toolbar.newBatch')}</Button>
            <Button onClick={onPrintBags}>{t('wms.sortingBatch.toolbar.printBags')}</Button>
            <Button onClick={onMoveIn}>{t('wms.sortingBatch.toolbar.moveIn')}</Button>
            <Button onClick={onMoveOut}>{t('wms.sortingBatch.toolbar.moveOut')}</Button>
            <Button onClick={onCancelBatches}>{t('wms.sortingBatch.toolbar.cancelBatches')}</Button>
            <span className="whitespace-nowrap text-xs text-[#86909c]">
                {selectedCount
                    ? t('wms.sortingBatch.toolbar.selectedBatches', { count: selectedCount })
                    : t('wms.sortingBatch.toolbar.noneSelected')}
            </span>
            <div className="flex-1" />
            <Button className="!border-[#ffd8a8] !bg-[#fff7e8] !text-[#c26b00]" onClick={onEndSorting}>
                {t('wms.sortingBatch.toolbar.endSorting')}
            </Button>
        </div>
    );
};
